import OrderDataSidebar from './OrderDataSidebar';

export default OrderDataSidebar;
